module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', [(!_vm.isAdding) ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Código")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.use_codigo),
      expression: "use_codigo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Código",
      "required": "",
      "disabled": !_vm.isAdding
    },
    domProps: {
      "value": (_vm.use_codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.use_codigo = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.use_data.nome),
      expression: "use_data.nome"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('nome')
    },
    attrs: {
      "type": "text",
      "placeholder": "Nome",
      "name": "nome",
      "required": ""
    },
    domProps: {
      "value": (_vm.use_data.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.use_data.nome = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Login")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.use_data.login),
      expression: "use_data.login"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('login')
    },
    attrs: {
      "type": "text",
      "placeholder": "Login",
      "name": "login",
      "disabled": !_vm.isAdding
    },
    domProps: {
      "value": (_vm.use_data.login)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.use_data.login = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icons-left has-icons-right"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.use_data.email),
      expression: "use_data.email"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('email')
    },
    attrs: {
      "type": "text",
      "placeholder": "E-mail",
      "name": "email",
      "disabled": !_vm.isAdding
    },
    domProps: {
      "value": (_vm.use_data.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.use_data.email = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), (!_vm.isAdding) ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Token")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.use_data.token),
      expression: "use_data.token"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "E-mail",
      "disabled": !_vm.isAdding
    },
    domProps: {
      "value": (_vm.use_data.token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.use_data.token = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.errors.any()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_vm._v("Salvar")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08a0745f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/users/UsersAddEdit.vue
// module id = 261
// module chunks = 1